<script lang="ts">
	interface Props {
		row: Record<string, string>
		key: string
	}

	let { row, key }: Props = $props()

	const status = $derived(row[key])
</script>

<div class="status-container">
	<div class="status {status}"></div>
	<div class="label">
		{status}
	</div>
</div>

<style>
	.status-container {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.label {
		font-family: 'inter', sans-serif;
		font-size: 16px;
		font-weight: 400;
		line-height: 23px;
		color: #606266;
	}
	.status {
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}

	.status.updated {
		background: #cb9a0b;
	}

	.status.trained {
		background: #5aa834;
	}

	.status.cloud {
		background: #000;
	}
</style>
